import React from 'react';
import Avatar from '@atlaskit/avatar';
import { AvatarLite } from '@atlassian/jira-business-avatar-lite';
import { DisplayName } from '@atlassian/jira-business-list/src/common/ui/list-cell/styled.tsx';
import { useIntl } from '@atlassian/jira-intl';
import type { ListViewControllerData } from '../../../../controllers/list-view-issues/types';
import messages from './messages';

export const AssigneeItem = ({ data }: { data: ListViewControllerData }) => {
	const { formatMessage } = useIntl();

	const isUnassigned = !data.assignee;
	const unassignedDisplayName = formatMessage(messages.unassignedDisplayName);
	const displayName = isUnassigned ? unassignedDisplayName : data.assignee?.displayName;

	return (
		<>
			{isUnassigned ? (
				<Avatar appearance="circle" src="" size="small" />
			) : (
				<AvatarLite avatarUrl={data.assignee?.avatarUrl} />
			)}
			<DisplayName>{displayName}</DisplayName>
		</>
	);
};
